import { Subject } from 'rxjs';

export class HamBurgerEventEmitter extends Subject<any>{
    constructor() {
        super();
    }
    emit(value) { super.next(value); }
}